import { SpaceType, TimeSpans } from '@/__generated__/types';
import type { DashboardPeriod } from '@/constants/dashboard-period';

import type { SpaceScope } from './types/home-types';

/** Placeholder variables for a skipped query while the portfolio scope resolves. */
export const UNRESOLVED_SCOPE: SpaceScope = {
  spaceId: '',
  spaceType: SpaceType.Site,
};

/**
 * Deep links into Insights, relative to the URL the backend tells for it.
 * Routes verified in insights-app/src/App.tsx
 */
export const INSIGHTS_PATHS = {
  energy: 'insights/energy/analysis',
  indoorClimate: 'insights/indoor-climate/dashboard',
  installations: 'insights/installation/dashboard',
  alarms: 'monitoring/alarms',
} as const;

export const PERIOD_LABEL_KEY: Record<DashboardPeriod, string> = {
  [TimeSpans.Last_7Days]: 'home.period.last7Days',
  [TimeSpans.Last_30Days]: 'home.period.last30Days',
  [TimeSpans.Last_366Days]: 'home.period.last12Months',
};

/** Keycloak client ids of the Home apps, in the order they are requested. */
export const APP_CLIENT_IDS = {
  insights: 'kxp-insights-app',
  twinStudio: 'kxp-twin-studio-app',
  // Temporary: Connect is served by its nginx client until it has its own
  connect: 'kxp-connect-nginx-app',
} as const;

/** Roles of the tenant users a "Learn more" request is sent to. */
export const LEARN_MORE_RECIPIENT_ROLES = [
  'contract-manager',
  'sustainability-officer',
  'sales-representative',
];
